import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { forgotPassword } from "../lib/adminApi";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
      <div className="w-full max-w-sm">
        <div className="bg-white border border-[#E5E7EB] rounded-sm shadow-sm p-8">
          <div className="flex items-center gap-2 mb-1">
            <Mail className="w-5 h-5 text-[#025979]" />
            <h1 className="text-xl font-bold text-[#1F2937]" style={{ fontFamily: "Chivo, sans-serif" }}>
              Reset your password
            </h1>
          </div>
          <p className="text-xs text-[#4B5563] mb-5 leading-relaxed">
            Enter the email on your account. If it exists, we&apos;ll send you a secure link to set a new password.
          </p>

          {sent ? (
            <div data-testid="forgot-success" className="rounded-sm border border-[#025979]/20 bg-[#E0F2FE] p-4">
              <div className="flex items-start gap-2">
                <CheckCircle2 className="w-4 h-4 text-[#025979] mt-0.5 shrink-0" />
                <div>
                  <p className="text-sm font-medium text-[#025979]">Check your inbox</p>
                  <p className="text-xs text-[#4B5563] mt-1 leading-relaxed">
                    If {email} is on file, a reset link is on its way. The link is valid for 24 hours.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-xs font-medium text-[#1F2937] block mb-1">Email</label>
                <Input
                  data-testid="forgot-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="rounded-sm"
                />
              </div>
              {error && <p className="text-xs text-red-500">{error}</p>}
              <Button
                type="submit"
                data-testid="forgot-submit"
                disabled={loading || !email}
                className="w-full bg-[#025979] hover:bg-[#03738C] text-white rounded-sm text-sm h-10"
              >
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          )}

          <button
            type="button"
            onClick={() => navigate("/transformation")}
            className="mt-5 inline-flex items-center gap-1 text-xs text-[#4B5563] hover:text-[#025979] transition-colors"
            data-testid="forgot-back"
          >
            <ArrowLeft className="w-3 h-3" /> Back to sign in
          </button>
        </div>
      </div>
    </div>
  );
}
